import React from 'react';
import PropTypes from 'prop-types';
import '../styles/info-block.css';
import {FormattedMessage} from 'react-intl';

const NewInfoBlock = props => {
  const Heading = props.headingLevel;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '16px'
      }}>
      {props.children}
      <Heading style={{color: '#00008D', marginTop: '16px', position: 'center'}}>
        <FormattedMessage id={props.title} />
      </Heading>
      <p style={{color: '#000', marginTop: '16px'}}>
        <FormattedMessage id={props.desc} />
      </p>
    </div>
  );
};

NewInfoBlock.propTypes = {
  image: PropTypes.element,
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired
};

export default NewInfoBlock;
